import dayjs from "dayjs";
import React from 'react';
import {useImmer} from "use-immer";
import {TagSensorDataGraph} from "../../components/graphs/TagSensorDataGraph";
import {
    DetailViewTabContainer,
    HorizontalSeparator,
} from "../../components/RustyRadeaComponents";
import {Table, Group, Text, useMantineTheme} from "@mantine/core";
import ENDPOINTS from "../../config/endpoint";
import {useAssets} from "../../hooks/RustyRadeaHooks";
import {IconChevronDown, IconChevronUp} from "@tabler/icons-react";

const SensorData = props => {
    const theme = useMantineTheme();
    const { latestSensors, fetch } = useAssets();
    const [sensorAlerts, setSensorAlerts] = useImmer([]);
    
    const [sensorData, setSensorData] = useImmer([]);
    
    React.useEffect(() => {
        updateData();
        
        const data_alert_socket = new WebSocket(ENDPOINTS('data_alerts_ws').replace('https://', 'wss://').replace('http://', 'ws://'));
        data_alert_socket.addEventListener('message', (event) => {
            const edata = JSON.parse(event.data);
            setSensorAlerts(draft => {
                if(edata.code === props.epc) draft.push({
                    ...edata,
                    timestamp: new Date().toISOString()
                });
            });
        });
        const sensor_data_socket = new WebSocket(ENDPOINTS('sensor_data_ws').replace('https://', 'wss://').replace('http://', 'ws://') + '?sensor_id=' + props.epc);
        sensor_data_socket.addEventListener('message', (event) => {
            const edata = JSON.parse(event.data);
            console.log('Received:', edata);
            setSensorData(draft => {
                // Check limit
                let over_limit = 0
                if(props.assetData.sensor_limits?.[edata.sensor_type]) {
                    if(edata.value > props.assetData.sensor_limits[edata.sensor_type]?.max) over_limit = 1;
                    else if(edata.value < props.assetData.sensor_limits[edata.sensor_type]?.min) over_limit = -1;
                }
                // Update
                let idx = draft.findIndex(e => e.sensor === edata.sensor_type);
                if(idx !== -1) {
                    draft[idx].value = edata.value;
                    draft[idx].over_limit = over_limit
                } else {
                    draft.push({
                        sensor: edata.sensor_type,
                        unit: edata.unit,
                        value: edata.value,
                        over_limit: over_limit,
                        created: new Date().toISOString()
                    });
                }
            })
        })
        return () => {
            data_alert_socket.close();
            sensor_data_socket.close();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.tag]);
    React.useEffect(() => {
        if(latestSensors) setSensorData(latestSensors);
    }, [latestSensors]);
    const updateData = () => {
        if(props.tag) fetch({tag: props.tag}, 'latestsensors');
    }
    
    return (
        <DetailViewTabContainer>
            <HorizontalSeparator text="Asset Sensor Data" size="sm" />
            
            <Table striped highlightOnHover mb={50}>
                <thead>
                    <tr>
                        <th>Sensor</th>
                        <th>Unit</th>
                        <th>Timestamp</th>
                        <th>Value</th>
                    </tr>
                    </thead>
                <tbody>
                    {(sensorData ?? []).map(entry => (
                        <tr key={entry.sensor}>
                            <td>{entry.sensor}</td>
                            <td>{entry.unit}</td>
                            <td>{entry.created ? dayjs(entry.created).format('HH:mm:ss || DD.MM.YYYY') : 'N/A'}</td>
                            <td style={{color: entry.over_limit === -1 ? '#9f9fff' : entry.over_limit === 1 ? 'red' : theme.colorScheme === 'dark' ? '#fff' : '#000'}}>
                                {entry.over_limit === -1 && <IconChevronDown />}{entry.over_limit === 1 && <IconChevronUp />} {entry.value}
                            </td>
                        </tr>
                    ))}
                    {(sensorData ?? []).length === 0 &&
                        <tr><td colSpan={4}>
                            <Group position="center" style={{height: 125, alignItems: 'center'}}>
                                <Text>No Sensor Data Present</Text>
                            </Group>
                        </td></tr>
                    }
                </tbody>
            </Table>
            
            <TagSensorDataGraph tag={props.epc} availableTypes={['Timescale']} defaultType="Timescale" />
            
            <div style={{ position: 'relative' }}>
                <Table striped highlightOnHover mb={50}>
                    <thead>
                    <tr>
                        <th>Time</th>
                        <th>Code</th>
                        <th>Alert Type</th>
                        <th>Sensor Type</th>
                        <th>Value</th>
                    </tr>
                    </thead>
                    <tbody>
                    {(sensorAlerts ?? []).toReversed().map((alert, idx) => (
                        <tr key={alert.timestamp}>
                            <td>{alert.timestamp ? dayjs(alert.timestamp).format('HH:mm:ss || DD.MM.YYYY') : 'N/A'}</td>
                            <td>{alert.code}</td>
                            <td>{alert.type}</td>
                            <td>{alert.sensor}</td>
                            <td style={{color: alert.limit === 'min' ? '#9f9fff' : 'red'}}>
                                {alert.limit === 'min' ? <IconChevronDown/> : <IconChevronUp/>} <span
                                style={{fontSize: '1rem'}}>{alert.value}</span>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </Table>
            </div>
        </DetailViewTabContainer>
    );
}
export default SensorData;
